import React from 'react'
import { Provider as StoreProvider } from 'react-redux'
import { configureStore } from 'app/session/store'
import { Router } from 'react-router-dom'
import { renderRoutes } from 'react-router-config'
import { createBrowserHistory } from 'history'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import MomentUtils from '@date-io/moment'
import 'assets/stylesheets/main.scss'
import { ThemeProvider } from '@material-ui/styles'
import theme from 'theme/config'
import { HelmetProvider } from 'react-helmet-async'
import { Configurator, LocalizationProvider } from 'components'
import { routes } from 'app/routes'
import { makeStyles } from '@material-ui/core'
import { homepage } from '../package.json';

const useStyles = makeStyles(() => ({
  root: {
    height: 'auto',
    minHeight: '100vh',
  },
  wrapper: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0,1)
    },
  },
}))

const App = () => {
  const history = createBrowserHistory({ basename: '/' + homepage })
  const store = configureStore()
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <main className={classes.wrapper}>
        <StoreProvider store={store}>
          <ThemeProvider theme={theme}>
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <Router history={history}>
                <HelmetProvider>
                  <LocalizationProvider>
                    <Configurator>
                      {renderRoutes(routes)}
                    </Configurator>
                  </LocalizationProvider>
                </HelmetProvider>
              </Router>
            </MuiPickersUtilsProvider>
          </ThemeProvider>
        </StoreProvider>
      </main>
    </div>
  )
}

export default App
